import { RedoOutlined, WarningOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';
import { Colors } from 'core/interfaces/variables.types';
import { TaskType } from 'core/modules/tasks/task.interface';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { eventStopPropagation } from 'src/utils/button';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TaskReferenceView = function TaskReferenceView(_ref) {
  var task = _ref.task;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return useMemo(function () {
    var _task$content;

    return /*#__PURE__*/_jsxs(Container, {
      onClick: eventStopPropagation,
      children: [task.type === TaskType.Report && ((_task$content = task.content) === null || _task$content === void 0 ? void 0 : _task$content.isFraud) && /*#__PURE__*/_jsx("span", {
        className: "is-fraud",
        children: /*#__PURE__*/_jsx(Tooltip, {
          title: t('task.isFraud'),
          children: /*#__PURE__*/_jsx(WarningOutlined, {})
        })
      }), /*#__PURE__*/_jsx("span", {
        children: task.reference
      }), /*#__PURE__*/_jsx("em", {
        children: "#".concat(task.version + 1)
      }), task.version > 0 && /*#__PURE__*/_jsx(Tooltip, {
        title: t('task.reopenLabel'),
        children: /*#__PURE__*/_jsx(Tag, {
          color: "processing",
          children: /*#__PURE__*/_jsx(RedoOutlined, {})
        })
      })]
    });
  }, [task.reference, task.version]);
}; // Styles

var Container = styled.span.withConfig({
  displayName: "Reference__Container",
  componentId: "sc-1lkhjzu-0"
})(["span.is-fraud{margin-right:8px;}em{margin-left:2px;color:", ";}.ant-tag{margin-left:5px;height:18px;line-height:16px;}"], Colors.grey[0]);